import React from "react"
import { Helmet } from "react-helmet"
import LoadExternalScript from "../utils/load-external-script"
import './Dataloft.scss';

const Dataloft = (props) => {
  let dataloftSrc = props.src.props.children;
  return (
    <>
      <LoadExternalScript
        src={dataloftSrc}
      />
      <div id="inform-widget" className="inform-widget-container"></div>
    </>
  )
}

export default Dataloft
